// Dark styled tooltip wrapper for FloatingPortal
import React from 'react';

import { FloatingPortal } from '@floating-ui/react';

import { cn } from '../../lib/utils';

import { TOOLTIP_BUBBLE_CLASS } from './Tooltip';

const SURFACES = {
  tooltip: 'tooltip-shadow rounded-2xl bg-gray-950/90 text-xs text-white backdrop-blur',
  // The canonical helper-tooltip bubble, shared with the Tooltip component.
  bubble: TOOLTIP_BUBBLE_CLASS,
  // Entity popovers (profile/channel/spammer): dark navy glass in the GlassWrapper
  // language — translucent + heavily saturated so imagery behind bleeds through,
  // with a hairline rim so the edge stays defined over plain white backgrounds.
  // Radius + shadow match the channel unit (ThreadList's panel card).
  'entity-popover':
    'rounded-2xl bg-gray-950/80 text-xs text-white shadow-[0_4px_16px_0_rgba(0,0,0,0.1)] backdrop-blur-lg backdrop-saturate-[2.2]',
};

// The positioner and the visual bubble are separate elements so an entrance
// transition's scale transform can't clobber floating-ui's position transform.
const DarkTooltipPortal = ({ setFloating, floatingStyles, floatingProps, children, zIndexClass, transitionStyles, variant = 'tooltip' }) => {
  const effectiveZIndexClass = zIndexClass ?? 'z-(--stack-tooltip)';
  return (
    <FloatingPortal>
      <div ref={setFloating} style={{ ...floatingStyles }} {...floatingProps} className={effectiveZIndexClass}>
        <div style={transitionStyles} className={cn(SURFACES[variant] ?? SURFACES.tooltip)}>
          {children}
        </div>
      </div>
    </FloatingPortal>
  );
};

export default DarkTooltipPortal;
